import { render, staticRenderFns } from "./ModalTextLink.vue?vue&type=template&id=7c83ae9c&scoped=true&"
import script from "./ModalTextLink.vue?vue&type=script&lang=ts&"
export * from "./ModalTextLink.vue?vue&type=script&lang=ts&"
import style0 from "./ModalTextLink.vue?vue&type=style&index=0&id=7c83ae9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c83ae9c",
  null
  
)

export default component.exports